module.exports = __webpack_public_path__ + "img/zk-icon-management-rule.a8b7c896.svg";